import * as DialogPrimitive from "@radix-ui/react-dialog";
import styles from "./dialog.module.css";

export const Dialog = ({
    triggerText,
    children,
    open,
    onOpenChange,
    triggerClassName = "",
    contentClassName = "",
    showCloseButton = true
}) => {
    return (
        <DialogPrimitive.Root open={open} onOpenChange={onOpenChange}>
            {triggerText && (
                <DialogPrimitive.Trigger asChild>
                    <button className={`${styles.Button} ${triggerClassName}`}>
                        {triggerText}
                    </button>
                </DialogPrimitive.Trigger>
            )}

            <DialogPrimitive.Portal>
                <DialogPrimitive.DialogTitle></DialogPrimitive.DialogTitle>
                <DialogPrimitive.Overlay className={styles.Overlay} />
                <DialogPrimitive.Content className={`${styles.Content} ${contentClassName}`}>
                    {children}

                    {showCloseButton && (
                        <DialogPrimitive.Close asChild>
                            <button className={styles.IconButton} aria-label="Close">
                                x
                            </button>
                        </DialogPrimitive.Close>
                    )}
                </DialogPrimitive.Content>
            </DialogPrimitive.Portal>
        </DialogPrimitive.Root>
    );
};
